/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} About_ClientsInputs */

const en_about_clients = /** @type {(inputs: About_ClientsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} clients`)
};

const ar_about_clients = /** @type {(inputs: About_ClientsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`أكثر من ${i?.count} عميلًا`)
};

const bn_about_clients = /** @type {(inputs: About_ClientsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ক্লায়েন্ট`)
};

const de_about_clients = /** @type {(inputs: About_ClientsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Kunden`)
};

const es_about_clients = /** @type {(inputs: About_ClientsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} clientes`)
};

const fr_about_clients = /** @type {(inputs: About_ClientsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} clients`)
};

const pt_about_clients = /** @type {(inputs: About_ClientsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} clientes`)
};

const zh_about_clients = /** @type {(inputs: About_ClientsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个客户`)
};

const tr_about_clients = /** @type {(inputs: About_ClientsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} müşteri`)
};

const ru_about_clients = /** @type {(inputs: About_ClientsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} клиентов`)
};

const pl_about_clients = /** @type {(inputs: About_ClientsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} klientów`)
};

/**
* | output |
* | --- |
* | "{count} clients" |
*
* @param {About_ClientsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const about_clients = /** @type {((inputs: About_ClientsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_ClientsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_about_clients(inputs)
	if (locale === "bn") return bn_about_clients(inputs)
	if (locale === "de") return de_about_clients(inputs)
	if (locale === "es") return es_about_clients(inputs)
	if (locale === "fr") return fr_about_clients(inputs)
	if (locale === "pt") return pt_about_clients(inputs)
	if (locale === "zh") return zh_about_clients(inputs)
	if (locale === "tr") return tr_about_clients(inputs)
	if (locale === "ru") return ru_about_clients(inputs)
	if (locale === "pl") return pl_about_clients(inputs)
	return en_about_clients(inputs)
});